<template>
  <div class="dashboard_stats" v-if="!load">
    <div class="card" v-if="device_groups_stat.data.length > 0">
      <div class="device_groups_stat">
        <h4 class="title">Device Groups Stat, online ({{ device_groups_stat.total  }})</h4>
        <div class="group_list">
          <p
              v-for="(device_group, key_stat) in device_groups_stat.data"
              :key="key_stat"
              class="group"
          >
            <router-link
                :to="get_name_link(device_group.group_id)"
                class="device_group"
            >
              <span>{{ device_group.name }}: </span>
            </router-link>

            <span>{{ device_group.online }} / {{ device_group.total }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="line">
      <div class="card" v-if="Object.keys(devices_stat).length > 0">
        <div class="devices_stat">
          <h4 class="title">Devices Stat</h4>

          <div class="statictics">
            <div
                v-for="(stat, key_stat) in devices_stat"
                :key="key_stat"
                class="stat"
            >
              <span>{{ key_stat }}: </span>
              <span>{{ stat }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="Object.keys(traffic_cost).length > 0">
        <div class="traffic_cost">
          <h4 class="title">Traffic Cost</h4>

          <div class="block">
            <div
                v-for="(traffic, traffic_key) in traffic_cost"
                :key="traffic_key"
                class="stat"
            >
              <p>{{ traffic_key }}:</p>

              <div
                  v-for="(elem, elem_key) in traffic"
                  class="elem_traffic"
              >
                <span> {{ elem_key }}: </span>
                <span>{{ elem }}</span>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="mno_accounts.length > 0">
        <div class="devices_stat">
          <h4 class="title">{{ translate("dashboard.stats.balance_on_account") }}</h4>

          <div class="accounts">
            <div
                v-for="(account, account_key) in mno_accounts"
                :key="account_key"
                class="stat"
            >
              <p>
                <span>{{account.name}}</span>
                <span>({{account.account}})</span>
                <span>{{account.used}} / {{account.limit}}</span>
                <span>({{get_date(account.ts_update)}})</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="card" v-if="Object.keys(simcards_stat.data).length > 0">
      <div class="simcards_stat">
        <h4 class="title">Simcards Stat, at devices - ({{ simcards_stat.total  }})</h4>
        <div class="group_list">
          <p
              v-for="(stat, key_stat) in simcards_stat.data"
              :key="key_stat"
              class="group stat"
          >
            <router-link :to="get_mo_link(key_stat)" class="device_group">
              <span>{{ key_stat }}: </span>
            </router-link>
            <span>{{ stat }}</span>
          </p>
        </div>

      </div>
    </div>

    <div class="card" v-if="Object.keys(users_stat).length > 0">
      <div class="users_stat">
        <h4 class="title">Users Stat</h4>

        <div class="statictics">
          <div
            v-for="(stat, key_stat) in users_stat"
            :key="key_stat"
            class="stat"
          >
            <template v-if="typeof stat == 'object'">
              <h5>{{ key_stat }}:</h5>
              <p v-for="(item, key_item) in stat" :key="key_item">
                <span>{{ key_item }}: </span>
                <span>{{ item }}</span>
              </p>
            </template>
            <template v-else>
              <span>{{ key_stat }}: </span>
              <span>{{ stat }}</span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "DashboardStats",
  components: {},
  data() {
    return {
      devices_stat: {},
      users_stat: {},
      simcards_stat: {},
      device_groups_stat: {},
      traffic_cost: {},
      mno_accounts: [],
      load: true
    };
  },

  created() {
    this.dashboard_stat();
  },

  watch: {},

  methods: {
    dashboard_stat() {
      this.$http.v1.dashboardStats((response) => {
        this.devices_stat = response.data.devices_stat;
        this.simcards_stat = response.data.device_simcards;
        this.users_stat = response.data.users;
        this.device_groups_stat = response.data.device_groups
        this.traffic_cost = response.data.traffic_cost
        this.mno_accounts = response.data.mno_accounts

        this.device_groups_stat.data.sort((a, b) => a.total < b.total ? 1 : -1)

        this.load = false
      });
    },
    get_name_link(group_id) {
      return { path: "/device_list?group=" + group_id };
    },
    get_mo_link(mno) {
      return { path: "/simcard_devices_list?mno=" + mno };
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard_stats {
  height: 100%;
  padding: 10px 0 0 0;
  .line{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    .card{
      height: 100%;
      flex: 1;
      margin-right: 10px;
      min-height: 160px;
      min-width: 250px;
      @media (max-width:550px) {
        width: 100%;
        margin-right: 0;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
  .card {
    margin-bottom: 10px;
    padding: 10px;
    .title {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 15px;
    }
    .group_list{
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-wrap: wrap;
      .group{
        width: 20%;
        min-width: 250px;
      }
    }
    .statictics {
      .stat {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 5px;
        p,
        span {
          font-size: 16px;
          margin: 0 5px 0 0;

          &:last-child {
            margin-right: 0;
          }
        }
        h5 {
          margin: 0 5px 0 0;
          font-size: 16px;
        }
      }
    }
    .accounts{
      span {
        font-size: 16px;
        margin-right: 5px;
      }
    }
    .traffic_cost{
      .block{
        display: flex;
        .stat{
          width: 100px;
          margin-right: 20px;
          text-align: left;
        }
        .elem_traffic{
          span{
            font-size: 14px;
          }

        }
      }

    }
  }
}

</style>
